import React from "react";
import JsxSyntaxHighlighter from "../../ui/JsxSyntaxHighlighter";
import ApiLink from "../../ui/ApiLink";

export default function ClearCallCache() {
  return (
    <>
      <JsxSyntaxHighlighter>
        {`type CacheClearable = string | MinibeakConfig;

clearCallCache(configsOrTags?: boolean | CacheClearable | Array<CacheClearable>)`}
      </JsxSyntaxHighlighter>

      <p>
        When called without parameters, or with false: Clears the entire call
        cache.
      </p>
      <p>
        When called with a string: Clears all caches with this{" "}
        <em>cache tag</em>.
      </p>
      <p>
        When called with a <ApiLink name="MinibeakConfig" />: clears the cache
        for this specific call.
      </p>

      <p>Can also be called with an array of tags or configs.</p>
    </>
  );
}
